import * as angular from "angular";
import { Constants as constants } from "@constants/shared";

import { ClientRepo as clientRepo } from "@services/clients/client.repo";
import { ClientCRMRepo } from "@services/clients/clientCRM.repo";
import { DropdownOptionsService } from "@services/clients/dropdownOptions.service";
import { PortfolioRepo } from "@services/portfolio.repo";
import { TradingRepo } from "@services/trading.repo";

import { clients } from "@app/clients/clients";
import { clientDetails } from "@app/clients/clients.details/clientdetails";
import { newPortfolioModal } from "@app/clients/clients.details/portfolio/modals/newportfolio.modal";
import { fixedHeaderModule } from "@common/fixed-header.directive";
import { editTradeRestrictionModal } from "@app/clients/clients.details/portfolio/modals/editTradeRestriction.modal";
import { portfolioTransfer } from "@app/clients/clients.details/portfolio/modals/portfolioTransfer.modal";
import { AddSignatoryRegimeModalComponent } from "@app/clients/clients.details/recipients/modals/add-signatory-regime.modal";
import { AuthorisedSignatoryPanelComponent } from "@app/clients/clients.details/recipients/modals/tabs/authorised-signatory/authorised-signatory-panel";
import { BeneficiaryPanelComponent } from "@app/clients/clients.details/recipients/modals/tabs/beneficiary/beneficiary-panel";
import { ClientDetailsGeneralComponent } from "./clients.details/general/clientdetails.general";
import { ClientDetailsReportingComponent } from "./clients.details/reporting/clientdetails.reporting";
import { ClientDetailsProfileComponent } from "@app/clients/clients.details/profile/clientdetails.profile";
import { newProfessionalActivityModal } from "@app/clients/clients.details/profile/modals/new-professional-activity.modal";
import { newAdditionalProfileModal } from "@app/clients/clients.details/profile/modals/new-additional-profile.modal";
import { newEmailAddressModal } from "@app/clients/clients.details/profile/modals/new-email-address.modal";
import { ClientDetailsBankingActivitiesComponent } from "@app/clients/clients.details/banking-activities/clientdetails.banking-activities";
import { ClientDetailsAccountReferenceComponent } from "@app/clients/clients.details/account-reference/clientdetails.account-reference";
import { ClientDetailsRecipientsComponent } from "@app/clients/clients.details/recipients/clientdetails.recipients";
import { ClientDetailsPortfolioComponent } from "@app/clients/clients.details/portfolio/clientdetails.portfolio";
import { ClientDetailsComplianceComponent } from "@app/clients/clients.details/compliance/clientdetails.compliance";
import { AddComplianceModalComponent } from "@app/clients/clients.details/compliance/modals/add-compliance-modal";
import { RiskMatrixPanelComponent } from "@app/clients/clients.details/compliance/modals/tabs/risk-matrix/risk-matrix-panel";
import { SourceOfFundsPanelComponent } from "@app/clients/clients.details/compliance/modals/tabs/source-of-funds/source-of-funds-panel";
import { DueDiligencePanelComponent } from "@app/clients/clients.details/compliance/modals/tabs/due-diligence/due-diligence-panel";
import { AddConnectionModalComponent } from "@app/clients/clients.details/connections/modals/add-connection-modal";
import { AddTransactionActivityModalComponent } from "@app/clients/clients.details/banking-activities/modals/add-transaction-activity-modal";
import { AddRestrictionModalComponent } from "@app/clients/clients.details/portfolio/modals/add-restriction-modal";
import { AddManagementFeeModalComponent } from "@app/clients/clients.details/portfolio/modals/add-management-fee-modal";
import { AddPortfolioExternalAccountModalComponent } from "@app/clients/clients.details/account-reference/modals/add-portfolio-external-account-modal";
import { ConnectionRepo } from "@services/clients/clients.details/connection.repo";
import { clientsFilterModal } from "@app/clients/modals/clients-filter-modal.component";
import { clientTypeSelectionModal } from "@app/clients/modals/client-type-selection-modal.component";
import { clientExportColumnsModal } from "@app/clients/modals/client-export-columns-modal.component";
import { feesModule } from "@app/fees/fees.index";

export const clientsModule = "clients";

angular
  .module(clientsModule, [
    "ui.router",
    "dataGrid",
    "pagination",
    "angular-loading-bar",
    "angularModalService",
    fixedHeaderModule,
    feesModule,
  ])
  .constant("config", constants.Default)
  .service("clientRepo", clientRepo)
  .service("clientCRMRepo", ClientCRMRepo)
  .service("dropdownOptionsService", DropdownOptionsService)
  .service("portfolioRepo", PortfolioRepo)
  .service("tradingRepo", TradingRepo)
  .service("connectionService", ConnectionRepo)
  .component("newPortfolioModal", newPortfolioModal)
  .component("clientDetails", clientDetails)
  .component("clients", clients)
  .component("editTradeRestrictionModal", editTradeRestrictionModal)
  .component("portfolioTransfer", portfolioTransfer)
  .component("addSignatoryRegimeModal", AddSignatoryRegimeModalComponent)
  .component("authorisedSignatoryPanel", AuthorisedSignatoryPanelComponent)
  .component("beneficiaryPanel", BeneficiaryPanelComponent)
  .component("clientdetailsGeneral", ClientDetailsGeneralComponent)
  .component("clientdetailsReporting", ClientDetailsReportingComponent)
  .component("clientdetailsProfile", ClientDetailsProfileComponent)
  .component("newProfessionalActivityModal", newProfessionalActivityModal)
  .component("newAdditionalProfileModal", newAdditionalProfileModal)
  .component("newEmailAddressModal", newEmailAddressModal)
  .component("clientdetailsBankingActivities", ClientDetailsBankingActivitiesComponent)
  .component("clientdetailsAccountReference", ClientDetailsAccountReferenceComponent)
  .component("clientdetailsRecipients", ClientDetailsRecipientsComponent)
  .component("clientdetailsPortfolio", ClientDetailsPortfolioComponent)
  .component("clientdetailsCompliance", ClientDetailsComplianceComponent)
  .component("addComplianceModal", AddComplianceModalComponent)
  .component("riskMatrixPanel", RiskMatrixPanelComponent)
  .component("sourceOfFundsPanel", SourceOfFundsPanelComponent)
  .component("dueDiligencePanel", DueDiligencePanelComponent)
  .component("addConnectionModal", AddConnectionModalComponent)
  .component("addTransactionActivityModal", AddTransactionActivityModalComponent)
  .component("addRestrictionModal", AddRestrictionModalComponent)
  .component("addManagementFeeModal", AddManagementFeeModalComponent)
  .component("addPortfolioExternalAccountModal", AddPortfolioExternalAccountModalComponent)
  .component("clientsFilterModal", clientsFilterModal)
  .component("clientTypeSelectionModal", clientTypeSelectionModal)
  .component("clientExportColumnsModal", clientExportColumnsModal)




// WEBPACK FOOTER //
// ./src/app/clients/clients.index.ts